




































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: mapState("adminUser", ["role"]),
})
export default class AdminUserMenu extends Vue {
  /* */
}
